// Every toast of the app goes through here, except the one that says the language changed
// (LanguageSwitch.jsx calls sonner itself). While TOASTS is off (lib/features.js), these
// calls do nothing.
import { toast as sonnerToast } from "sonner";
import { TOASTS } from "./features";

const none = () => {};
const silent = Object.assign(none, { success: none, error: none, info: none, warning: none });

export const toast = TOASTS ? sonnerToast : silent;
